import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { css } from "styled-components";

// EC-761 : My List Details Page : Added dynamic css through code
headerStyles.container = {
    gap: 15,
    css: css`
        margin: 10px 0px;
    `,
};
// EC-761 : My List Details Page : Added dynamic css through code
